import React from 'react';

function Messages() {
  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-white p-6 sm:p-8 shadow-sm">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-navy">Messages</h1>
        <p className="mt-2 text-sm text-slate-600">Your conversations will appear here.</p>
      </div>

      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <p className="text-sm text-slate-700">No messages yet.</p>
      </div>
    </div>
  );
}

export default Messages;

